import * as helper from './../../../../../VX/View/Assets/Js/helper';
import AlertBox from './AlertBox';

export default class Section5 {
	constructor() {
		this.day = helper.$('#day');
		this.month = helper.$('#month');
		this.year = helper.$('#year');
		this.family = helper.$('#family');
		this.alertBox = new AlertBox(helper.$('#section5'));
	}

	get values() {
		return {
			'birth': this.year.value + '-' + this.month.value + '-' + this.day.value,
			'familyStatus': this.family.value
		};
	}

	isValid() {
		if (this.day.value === '' || this.month.value === '' || this.year.value === '') {
			helper.addClass(this.day, 'alertborder');
			helper.addClass(this.month, 'alertborder');
			helper.addClass(this.year, 'alertborder');
			this.alertBox.show('Bitte gib dein Geburtsdatum an!');
			return false;
		}

		helper.removeClass(this.day, 'alertborder');
		helper.removeClass(this.month, 'alertborder');
		helper.removeClass(this.year, 'alertborder');

		if (this.family.value === '') {
			helper.addClass(this.family, 'alertborder');
			this.alertBox.show('Bitte gib deinen Beziehungsstatus an!');
			return false;
		}

		helper.removeClass(this.family, 'alertborder');
		this.alertBox.hide();
		return true;
	}
}
